import React from "react";
import PublicHelpWidget from "./PublicHelpWidget";

export default function PublicPageLayout({ children, hideHelp = false }) {
  return (
    <>
      {children}
      {!hideHelp && <PublicHelpWidget />}
    </>
  );
}
